const PRIMARY_HOSTS = ['play.yaknetwork.com', 'localhost'];

interface DomainResolution {
  type: 'slug' | 'custom_domain';
  value: string;
}

/**
 * Resolves the landing page identifier from the current URL.
 * - Primary hosts (play.yaknetwork.com, localhost): extract slug from path
 * - Custom domains: use hostname as the slug identifier
 */
export function resolveDomain(hostname: string, pathname: string): DomainResolution {
  // Strip port from hostname
  const host = hostname.split(':')[0].toLowerCase();

  if (PRIMARY_HOSTS.includes(host)) {
    // Extract slug from path (full path as composite slug)
    const slug = pathname.split('/').filter(Boolean).join('/');
    return { type: 'slug', value: slug };
  }

  // Custom domain: the hostname itself is the identifier
  return { type: 'custom_domain', value: host };
}

/**
 * Checks if the current host is a primary (known) host.
 */
export function isPrimaryHost(hostname: string): boolean {
  const host = hostname.split(':')[0].toLowerCase();
  return PRIMARY_HOSTS.includes(host);
}
